import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/HelpOutline';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import CardDetails from './CardDetails';

const styles = theme => ({
  paper: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  helpIcon: {
    marginLeft: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  }
});

class History extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openDialog: false,
      dialogCards: [],
      dateVal: 1,
      cards: [],
      cardsMap: {},
    }

    this.getHistory = this.getHistory.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen = (cardKey) => {
    this.setState({openDialog: true, dialogCards: this.state.cardsMap[cardKey]})
  };

  handleClose = () => {
    this.setState({openDialog: false})
  };

  componentDidMount() {
    this.getHistory(this.state.dateVal)
  }

  getHistory = async (hours) => {
    this.setState({cards: []})

    let date = new Date();
    date.setHours(date.getHours()+8-hours);
    let cardsMap = {}
    let cardsArr = []
    let done = false
    let offset = 0

    while(!done) {
      let res = await fetch('https://api.opensea.io/api/v1/events?asset_contract_address=0x0e3a2a1f2146d86a604adc220b4967a898d7fe07&event_type=successful&limit=100&offset='+offset)
      let data = await res.json()

      data.asset_events.forEach(event => {
        let asset = event.asset
        let cardTime = new Date(event.event_timestamp)
        if (asset && cardTime > date) {
          if (cardsMap[asset.image_thumbnail_url]) {
            cardsMap[asset.image_thumbnail_url].push({ name: asset.name, thumbnail: asset.image_thumbnail_url, preview: asset.image_preview_url, price: event.total_price/1000000000000000000, time: event.event_timestamp });
          } else {
            cardsMap[asset.image_thumbnail_url] = [{ name: asset.name, thumbnail: asset.image_thumbnail_url, preview: asset.image_preview_url, price: event.total_price/1000000000000000000, time: event.event_timestamp }]
          }
        }

        done = (cardTime < date) ? true : false
        offset++
      })
    }

    for (let item in cardsMap) {
      let asset = cardsMap[item]
      cardsArr.push({ name: asset[0].name, thumbnail: asset[0].thumbnail, count: asset.length })
    }

    cardsArr.sort((a,b) => {
      return (a.count < b.count) ? 1 : -1
    })

    this.setState({cards: cardsArr, cardsMap: cardsMap})
  }

  handleChange = (e) => {
    let val = e.target.value
    this.setState({dateVal: val})
    this.getHistory(val)
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Toolbar>
              <Typography>
                Last
              </Typography>
              <FormControl className={classes.formControl}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.dateVal}
                  onChange={this.handleChange}
                >
                  <MenuItem value={1}>1 hr</MenuItem>
                  <MenuItem value={3}>3 hrs</MenuItem>
                  <MenuItem value={6}>6 hrs</MenuItem>
                  <MenuItem value={12}>12 hrs</MenuItem>
                  <MenuItem value={24}>24 hrs</MenuItem>
                </Select>
              </FormControl>
              <Tooltip className={classes.helpIcon} placement="right" title="Shows cards bought since the given time.">
                <HelpIcon fontSize="small" />
              </Tooltip>
            </Toolbar>
            {this.state.cards.length <= 0 &&
              <CircularProgress />
            }
            {this.state.cards.length > 0 &&
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Volume</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.cards.map((card, index) => {
                    return (
                      <Tooltip key={index} className={classes.helpIcon} placement="right" title="Click for details">
                        <TableRow hover onClick={() => this.handleOpen(card.thumbnail)}>
                          <TableCell><Avatar variant="square" alt={card.name} src={card.thumbnail} /></TableCell>
                          <TableCell>{card.name.substr(0, card.name.indexOf("ID #")-1)}</TableCell>
                          <TableCell>{card.count}</TableCell>
                        </TableRow>
                      </Tooltip>
                    );
                  })}
                </TableBody>
              </Table>
            }
          </Paper>
        </Grid>
        <CardDetails open={this.state.openDialog} cards={this.state.dialogCards} handleClose={this.handleClose}/>
      </React.Fragment>
    );
  }
}

History.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(History);